import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6C12.4142 6 12.75 6.33579 12.75 6.75V10.75C12.75 11.1642 12.4142 11.5 12 11.5C11.5858 11.5 11.25 11.1642 11.25 10.75V6.75C11.25 6.33579 11.5858 6 12 6Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.5 4.25C1.5 3.2835 2.2835 2.5 3.25 2.5H20.75C21.7165 2.5 22.5 3.2835 22.5 4.25V16.75C22.5 17.7165 21.7165 18.5 20.75 18.5H11.1642C11.0979 18.5 11.0343 18.5263 10.9874 18.5732L7.48744 22.0732C7.21418 22.3465 6.84356 22.5 6.45711 22.5C5.65237 22.5 5 21.8476 5 21.0429V18.5H3.25C2.2835 18.5 1.5 17.7165 1.5 16.75V4.25ZM3.25 4C3.11193 4 3 4.11193 3 4.25V16.75C3 16.8881 3.11193 17 3.25 17H5.75C6.16421 17 6.5 17.3358 6.5 17.75V20.9393L9.92678 17.5126C10.255 17.1844 10.7001 17 11.1642 17H20.75C20.8881 17 21 16.8881 21 16.75V4.25C21 4.11193 20.8881 4 20.75 4H3.25Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgReport;
